import { createReducer } from "typesafe-actions";
import { OAuthToken } from "../../../oauth";
import { authAsync, logoutAsync } from "./sagas";

export interface AuthReducerState {
  token: OAuthToken;
  loading: boolean;
}

const storage = localStorage.getItem("auth") || "";

const initalState: AuthReducerState = {
  loading: false,
  token: new OAuthToken(JSON.parse(storage || "null")),
};

export const authReducer = createReducer<AuthReducerState>({
  ...initalState,
})
  .handleAction(
    authAsync,
    (state: AuthReducerState, action: any): AuthReducerState => {
      return {
        token: new OAuthToken(action.payload),
        loading: true,
      }
    }
  )
  .handleAction(
    logoutAsync,
    (state: AuthReducerState, action: any): AuthReducerState => {
      localStorage.removeItem("auth");
      return {
        ...state,
        token: new OAuthToken(JSON.parse("null")),
      };
    }
  );
